import React, { Component } from 'react';
import {
	Modal, Row, Col, Button,
} from 'react-bootstrap';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

class PaymentConfirmationModal extends Component {
	shouldComponentUpdate = ({ showModal : nextShowModal }) => {
		const { showModal } = this.props;
		return !isEqual(showModal, nextShowModal);
	}

	render() {
		const {
			showModal, title, handleOnClick, cancelBtnTxt, confirmBtnTxt,
		} = this.props;
		return (
			<Modal
				show={showModal}
				onHide={() => handleOnClick('cancel')}
			>
				<Modal.Header closeButton>
					<Modal.Title>Confirm</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12}>
							{ title }
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						bsStyle="link"
						onClick={() => handleOnClick('cancel')}
					>
						{ cancelBtnTxt }
					</Button>
					<Button
						bsStyle="primary"
						className="btn btn-medium"
						onClick={() => handleOnClick('confirm')}
					>
						{ confirmBtnTxt }
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

PaymentConfirmationModal.propTypes = {
	showModal     : PropTypes.bool,
	title         : PropTypes.string,
	handleOnClick : PropTypes.func,
	cancelBtnTxt  : PropTypes.string,
	confirmBtnTxt : PropTypes.string,
};

PaymentConfirmationModal.defaultProps = {
	showModal     : false,
	title         : '',
	handleOnClick : undefined,
	cancelBtnTxt  : 'Cancel',
	confirmBtnTxt : 'Confirm',
};

export default PaymentConfirmationModal;
